module.exports = __webpack_public_path__ + "img/Spinnmaschinen.d1a1a41f.jpg";